import { FieldType } from 'controls/queryBuilder/ruleDefinition';

import { BindableVariable } from '../types';
import { isVariableSuitable } from './isVariableSuitable';

// the suitable ones first; the others are shown too, to tell they exist
export function getVariableChoices(variables: BindableVariable[], type: FieldType, list: boolean) {
	const choices = variables.map((variable) => ({ variable, suitable: isVariableSuitable(variable, type, list) }));
	return [...choices.filter((x) => x.suitable), ...choices.filter((x) => !x.suitable)];
}
